import { Component, HostListener, Inject, OnInit, forwardRef } from '@angular/core';
import { MODAL_DATA, ModalService } from 'app/tools/modal/modal.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'avatar-cropper-modal',
  templateUrl: './avatar-cropper-modal.component.html',
  styleUrls: ['./avatar-cropper-modal.component.scss']
})
export class AvatarCropperModalComponent implements OnInit {

  imageChangedEvent: Event;
  croppedImage: string;

  @HostListener('document:keydown.escape', ['$event']) onEscClick(event: KeyboardEvent) {    
    event.preventDefault();
    this._modalService.dismiss();
  }

  constructor(
    @Inject(forwardRef(() => MODAL_DATA)) public params,
    private _modalService: ModalService<AvatarCropperModalComponent>
  ) { }

  ngOnInit() {
    this.imageChangedEvent = this.params;
  }

  salvar(event) {
    this._modalService.dismiss({ data: this.croppedImage });
  }

  fechar(event) {
    this._modalService.dismiss();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
}
